import { Link } from 'react-router-dom';

const SpecialOfferSection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-[#C4A962] to-[#B39952] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-block bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
            <span className="text-white font-semibold text-sm">Special Offers</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Start Your Custom Experience Today
          </h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Take advantage of our complimentary services and experience the Custom Clothiers difference
          </p>
        </div>

        {/* Offers Grid - Three Distinct Card Styles */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          
          {/* Card 1: Free Consultation - Large Icon with Gradient and Number Badge */}
          <div className="bg-white rounded-2xl p-8 text-center relative overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
            <div className="absolute top-4 right-4 w-12 h-12 bg-gradient-to-br from-[#C4A962] to-[#B39952] rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-lg">01</span>
            </div>
            <div className="relative mb-6">
              <div className="w-24 h-24 bg-gradient-to-br from-[#C4A962]/20 to-[#B39952]/20 rounded-3xl flex items-center justify-center mx-auto transform rotate-6">
                <div className="w-20 h-20 bg-gradient-to-br from-[#C4A962] to-[#B39952] rounded-2xl flex items-center justify-center transform -rotate-6">
                  <i className="ri-gift-line text-white text-4xl"></i>
                </div>
              </div>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Free Consultation</h3>
            <p className="text-gray-600 leading-relaxed">Complimentary style consultation and fabric selection guidance</p>
          </div>

          {/* Card 2: Free Swatches - Horizontal Layout with Styled Header */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
            <div className="h-32 relative overflow-hidden bg-gradient-to-br from-amber-50 to-yellow-100 flex items-center justify-center">
              <div className="absolute inset-0 opacity-20" style={{
                backgroundImage: 'repeating-linear-gradient(45deg, #C4A962 0px, #C4A962 2px, transparent 2px, transparent 12px)',
              }}></div>
              <div className="relative flex items-center gap-3">
                <div className="w-12 h-12 bg-[#C4A962] rounded-xl flex items-center justify-center shadow-md">
                  <i className="ri-layout-grid-2-line text-white text-2xl"></i>
                </div>
                <div className="w-12 h-12 bg-[#B39952] rounded-xl flex items-center justify-center shadow-md opacity-80">
                  <i className="ri-palette-line text-white text-2xl"></i>
                </div>
                <div className="w-12 h-12 bg-[#C4A962]/70 rounded-xl flex items-center justify-center shadow-md">
                  <i className="ri-scissors-cut-line text-white text-2xl"></i>
                </div>
              </div>
              <div className="absolute bottom-3 left-4 bg-[#C4A962] rounded-full px-3 py-1">
                <span className="text-white font-bold text-sm">5000+ Fabrics</span>
              </div>
            </div>
            <div className="p-6">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-12 h-12 bg-[#C4A962]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-send-line text-[#C4A962] text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Free Swatches</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">Request fabric swatches mailed to your home at no charge</p>
                </div>
              </div>
            </div>
          </div>

          {/* Card 3: House Calls - Dark Inverted Style with Map Pin */}
          <div className="bg-gray-900 rounded-2xl p-8 text-center relative overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#C4A962]/10 rounded-full -mr-16 -mt-16"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#C4A962]/10 rounded-full -ml-12 -mb-12"></div>
            <div className="relative">
              <div className="w-20 h-20 bg-[#C4A962] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className="ri-home-office-line text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">House Calls Available</h3>
              <p className="text-gray-300 leading-relaxed mb-4">Convenient in-home or office fittings throughout Massachusetts</p>
              <div className="inline-flex items-center gap-2 text-[#C4A962] text-sm font-semibold">
                <i className="ri-map-pin-line"></i>
                <span>All of MA</span>
              </div>
            </div>
          </div>

        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/contact"
            className="bg-white text-[#C4A962] px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap w-full sm:w-auto"
          >
            <i className="ri-calendar-line mr-2"></i>
            Schedule Free Consultation
          </Link>
          <a
            href="tel:781-237-3166"
            className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-[#C4A962] transition-all transform hover:scale-105 whitespace-nowrap w-full sm:w-auto"
          >
            <i className="ri-phone-line mr-2"></i>
            Call 781-237-3166
          </a>
        </div>
      </div>
    </section>
  );
};

export default SpecialOfferSection;